module.exports = __webpack_public_path__ + "static/media/risk1.545079de.jpg";